import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg, resolveUrl } from "@/lib/api";
import { useApi } from "@/lib/useApi";
import { MaterialIcon } from "@/components/MaterialIcon";
import { PageTitle, btnPrimary, card } from "@/components/admin/ui";
import { formatDateRange } from "@/lib/format";

export default function AdminFestivals() {
  const { data: festivals } = useApi("/admin/festivals");
  const navigate = useNavigate();

  const create = async () => {
    try {
      const { data } = await api.post("/admin/festivals", { name: "Untitled Festival" });
      navigate(`/admin/festivals/${data.id}`);
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  return (
    <div data-testid="admin-festivals-page">
      <PageTitle title="Festivals">
        <button type="button" className={btnPrimary} onClick={create} data-testid="add-festival-button">
          <MaterialIcon name="add" size={20} weight={600} />
          Add Festival
        </button>
      </PageTitle>
      <div className={`${card} divide-y divide-[#E5E7EB]`} data-testid="admin-festival-list">
        {festivals?.map((f) => (
          <Link key={f.id} to={`/admin/festivals/${f.id}`} className="flex items-center gap-4 p-3 hover:bg-[#F9FAFB] transition-colors" data-testid={`admin-festival-row-${f.id}`}>
            <div className="w-16 h-16 rounded bg-[#E5E7EB] overflow-hidden shrink-0">
              {(f.cover_image_url || f.logo_url) && <img src={resolveUrl(f.cover_image_url || f.logo_url)} alt="" className="w-full h-full object-cover" />}
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-[14px] font-semibold truncate" data-testid="admin-festival-name">{f.name}</p>
              <p className="text-[12px] text-[#6B7280] truncate">
                {formatDateRange(f.start_date, f.end_date) || "No dates"}{f.location ? ` · ${f.location}` : ""} · {f.video_count} video{f.video_count === 1 ? "" : "s"} · {f.passes?.length || 0} pass tier{f.passes?.length === 1 ? "" : "s"}
              </p>
            </div>
          </Link>
        ))}
        {festivals && festivals.length === 0 && <p className="p-8 text-center text-[14px] text-[#6B7280]">No festivals yet. Click “Add Festival” to create a template.</p>}
      </div>
    </div>
  );
}
